// extracted by mini-css-extract-plugin
export default {"modalOverlay":"EditUserInfoModal_modalOverlay__o7Xbt","modalContent":"EditUserInfoModal_modalContent__dPT8H","buttons":"EditUserInfoModal_buttons__rISp7"};